import {
  DESKTOP_BREAKPOINT,
  TABLET_BREAKPOINT,
  LARGE_DESKTOP_BREAKPOINT,
  TABLET_BREAKPOINT_PLUS,
} from '../../consts/media-breakpoint';

export enum MediaBreakpoints {
  tablet = `(min-width: ${TABLET_BREAKPOINT}px)`,
  tabletPlus = `(min-width: ${TABLET_BREAKPOINT_PLUS}px)`,
  desktop = `(min-width: ${DESKTOP_BREAKPOINT}px)`,
  largeDesktop = `(min-width: ${LARGE_DESKTOP_BREAKPOINT}px)`,
}
